const createProductSchema = ({
  name,
  description,
  url,
  image,
  category
}) => {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": `${url}#product`,

    "name": name,

    "description": description,

    "url": url,

    "brand": {
      "@type": "Brand",
      "name": "Gurukrupa Wood Pvt. Ltd."
    },

    "manufacturer": {
      "@id": "https://gurukrupawood.com/#organization"
    }
  };
};

export default createProductSchema;